import React from "react";
import "./who.css";
import { FaLinkedin, FaGithub, FaGlobe, FaInstagram } from "react-icons/fa";
import { FaXTwitter, FaBluesky } from "react-icons/fa6";
import ProgressiveImage from "../components/Image/ProgressiveImage";

function Person({
  imgSrc = "",
  alt = "",
  name,
  role,
  links = []
}) {
  const webLink = links.find(link => link.type === 'web')?.href;

  return (
    <div className="person">
      <div className="avatar">
        {webLink ? (
          <a href={webLink} target="_blank" rel="noopener noreferrer">
            {imgSrc ? <ProgressiveImage src={imgSrc} alt={alt || name} /> : <span>image</span>}
          </a>
        ) : (
          imgSrc ? <ProgressiveImage src={imgSrc} alt={alt || name} /> : <span>image</span>
        )}
      </div>

      <h3 className="name">{name}</h3>
      
      {!!links.length && (
        <ul className="social">
          {links.map(({ type, href }, i) => {
            let Icon;
            switch (type) {
              case 'linkedin':
                Icon = FaLinkedin;
                break;
              case 'twitter':
                Icon = FaXTwitter;
                break;
              case 'github':
                Icon = FaGithub;
                break;
              case 'web':
                Icon = FaGlobe;
                break;
              case 'bluesky':
                Icon = FaBluesky;
                break;
              case 'instagram':
                Icon = FaInstagram;
                break;
              default:
                return null;
            }
            return (
              <li key={i}>
                <a href={href} target="_blank" rel="noopener noreferrer" aria-label={`${type} profile`}>
                  <Icon />
                </a>
              </li>
            );
          })}
        </ul>
      )}

      <p className="role">{role}</p>
    </div>
  );
}

export default function WhoDidThis() {
  return (
    <section className="whodidthisbackground">
      <div className="whodidthis">
        <h1>The people behind this tracker</h1>
        <p className="subtitle">Reach out if you'd like to learn more!</p>

        <div className="people-grid">
          <Person
            imgSrc="/images/Dan_Tomlinson_MP_cropped.jpg"
            name="Dan Tomlinson MP"
            role="Dan is the Labour Member of Parliament for Chipping Barnet in North London. He is the government’s growth mission champion and worked as an economist prior to being elected."
            links={[
              { type: 'web', href: 'https://www.dantomlinson.org.uk/' },
              { type: 'instagram', href: 'http://instagram.com/dantomlinsonmp' },
              { type: 'bluesky', href: 'https://bsky.app/profile/dantomlinson.bsky.social' },
              { type: 'twitter', href: 'https://x.com/Dan4Barnet' },
            ]}
          />

          {/* <Person
            name="Centre for British Progress"
            role="A think tank on a mission to accelerate and shape an era of British growth and progress."
            imgSrc="/images/cbp.png"
            links={[
              { type: 'web', href: 'https://britishprogress.org' },
              { type: 'bluesky', href: 'https://bsky.app/profile/britishprogress.bsky.social' },
              { type: 'twitter', href: 'https://x.com/britishprogress' },
            ]}
          /> */}

          <Person
            name="Matt Collins"
            role="Matt Collins is a District Councillor in Warwick and has a background in data engineering, AI, and strategy. Matt built this tracker on a voluntary basis with an aim of improving infrastructure transparency."
            imgSrc="/images/matt.jpg"
            links={[
                { type: 'linkedin', href: 'https://www.linkedin.com/in/mjpcollins/'},
                { type: 'instagram', href: 'https://www.instagram.com/cllrmattcollins' },
                { type: 'bluesky', href: 'https://bsky.app/profile/matt-collins.bsky.social'},
                { type: 'twitter', href: 'https://x.com/mattjpcollins'},

            ]}
          />
        </div>
      </div>
    </section>
  );
}
